import { render, staticRenderFns } from "./classHour.vue?vue&type=template&id=3729e442&scoped=true"
import script from "./classHour.vue?vue&type=script&lang=js"
export * from "./classHour.vue?vue&type=script&lang=js"
import style0 from "./classHour.vue?vue&type=style&index=0&id=3729e442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3729e442",
  null
  
)

export default component.exports